import { forwardRef, useImperativeHandle, useState } from 'react';
import type { SegmentsProps, SegmentsRef } from '../model/types';
import { classNames } from '@/shared/lib/classNames';
import { SegmentItem } from './SegmentItem';
import { getInitialValue, getSizeClassName } from '../model/utils';
import cls from './Segments.module.scss';

export const Segments = forwardRef<SegmentsRef, SegmentsProps>(({ className, items, initialValue, size, onChange }, ref) => {
    const [selectedItem, setSelectedItem] = useState(() => getInitialValue(items, initialValue));

    const sizeClassName = getSizeClassName(size, cls);

    useImperativeHandle(ref, () => ({
        reset: () => {
            setSelectedItem(null);
        },
    }));

    return (
        <div className={cls.wrapper}>
            <div className={classNames(cls.container, {}, [className, sizeClassName])}>
                {items.map(({ label, value }) => {
                    const isActive = selectedItem === value;

                    return (
                        <SegmentItem
                            size={size}
                            key={value}
                            label={label}
                            value={value}
                            isActive={isActive}
                            onClick={(value: string) => {
                                setSelectedItem(value);
                                onChange?.(value);
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
});

Segments.displayName = 'Segments';
